module.exports = __webpack_public_path__ + "img/pdf-download-green.9410979d.svg";